<!--
// IMPORTANT: mat-tab breaks TinyMCE, so we need to destroy/init is when changing tabs
// This issue appears as the editor rendering, but having no data / not accepting input
// https://github.com/tinymce/tinymce-angular/issues/105
// https://github.com/tinymce/tinymce-angular/blob/main/stories/materialtabs/MaterialTabs.component.html
-->

<!--
This ngIf passes doesn't block on the truthyness of isEditorReady$, but assigns it to a variable.
Because we need the <textarea> to be in the DOM.
https://medium.com/ngconf/handling-falsy-valued-emitted-from-observables-in-angular-bc1c28642107
-->

<!-- force reload of widget because tinymce doesnt allow toggling between themes on the fly -->
@if (theme() === GalaxyTheme.Dark) {
  <ng-container *ngTemplateOutlet="tinymceTemplate"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="tinymceTemplate"></ng-container>
}
<ng-template #tinymceTemplate>
  @if ({ isEditorReady: isEditorReady() }; as data) {
    <div [hidden]="!data.isEditorReady" class="editor-container">
      <!--
      Deadlock pitfall: this element must be in the DOM for the editor to initialize,
      but this won't render if conditioned on isEditorReady$ (i.e. ngIf).
      -->
      <textarea id="{{ elementId }}-{{ this.theme() }}"></textarea>
    </div>
    @if (!data.isEditorReady) {
      <div class="loading-screen">
        <mat-spinner diameter="32" />
      </div>
    }
  }
</ng-template>
